// eslint-disable-next-line import/extensions, import/no-unresolved
import { IAppConfig } from './type/app-config';

export const msalConfig = (appConfig: IAppConfig) => {
  return {
    auth: {
      clientId: appConfig.VITE_CLIENT_ID,
      authority: `${appConfig.VITE_AUTHORITY}/${appConfig.VITE_TENANT_ID}`,
      redirectUri: appConfig.VITE_REDIRECT_URL,
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false,
    },
  };
};

export const loginRequest = {
  scopes: ['User.Read'],
};
